import { WorkspaceAvatar } from "@design-system/Avatar/WorkspaceAvatar";
import { EmptyCellValue } from "@design-system/DataGrid";
import {
    useTaskClientIconColor,
    useTaskClientName,
} from "../../taskClientNamesContext";
import { TaskAvatarLabel } from "./TaskAvatarLabel";
import { type TaskListTaskRow, toReadOnlyTaskCell } from "./taskRowCells";

const TaskClient = ({ task }: { task: TaskListTaskRow }) => {
    const clientName = useTaskClientName(task.workspaceId);
    const iconColor = useTaskClientIconColor(task.workspaceId);

    if (!clientName) {
        return <EmptyCellValue empty="dash" />;
    }
    return (
        <TaskAvatarLabel
            avatar={
                <WorkspaceAvatar
                    workspace={{ name: clientName, iconColor }}
                    aria-hidden
                />
            }
            label={clientName}
        />
    );
};

/** The Client column's task rows: the task's client logo and name. */
export const TaskClientCell = toReadOnlyTaskCell(TaskClient);
